import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type UpdateRegistryPageContainerNoteMutationVariables = Types.Exact<{
  payload: Types.PageContainerUpdatePayload;
}>;

export type UpdateRegistryPageContainerNoteMutation = { __typename?: 'Mutation'; updatePageContainer: { __typename?: 'PageContainer'; id: string; note?: string | null } };

export const UpdateRegistryPageContainerNoteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRegistryPageContainerNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageContainerUpdatePayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePageContainer' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateRegistryPageContainerNoteMutationFn = Apollo.MutationFunction<UpdateRegistryPageContainerNoteMutation, UpdateRegistryPageContainerNoteMutationVariables>;

/**
 * __useUpdateRegistryPageContainerNoteMutation__
 *
 * To run a mutation, you first call `useUpdateRegistryPageContainerNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistryPageContainerNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegistryPageContainerNoteMutation, { data, loading, error }] = useUpdateRegistryPageContainerNoteMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateRegistryPageContainerNoteMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRegistryPageContainerNoteMutation, UpdateRegistryPageContainerNoteMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateRegistryPageContainerNoteMutation, UpdateRegistryPageContainerNoteMutationVariables>(
    UpdateRegistryPageContainerNoteDocument,
    baseOptions,
  );
}
export type UpdateRegistryPageContainerNoteMutationHookResult = ReturnType<typeof useUpdateRegistryPageContainerNoteMutation>;
export type UpdateRegistryPageContainerNoteMutationResult = Apollo.MutationResult<UpdateRegistryPageContainerNoteMutation>;
export type UpdateRegistryPageContainerNoteMutationOptions = Apollo.BaseMutationOptions<UpdateRegistryPageContainerNoteMutation, UpdateRegistryPageContainerNoteMutationVariables>;
